module.exports = __webpack_public_path__ + "img/w-wa_robot_yay.c3e75331.png";